export default __webpack_public_path__ + "static/media/facebook.9ea2cd74.svg";